import { Box, Chip, Link } from '@mui/material'
import { styled } from '@mui/material/styles'

export const Container = styled(Box)(({ theme }) => ({
  overflowX: 'hidden',
  overflowY: 'scroll',
  height: 'calc(100vh - 152px)',

  '& .title': {
    fontSize: '16px',
    color: theme.palette.text.primary,
    lineHeight: '18px',
    letterSpacing: '0.15px',
    fontWeight: '500',
    marginTop: 12,
  },

  '& .content': {
    marginTop: '8px',
    padding: '8px',
    borderRadius: theme.shape.customBorderRadius.main,
    backgroundColor: theme.palette.grey[50],

    '& .MuiTypography-root': {
      fontSize: '16px',
      lineHeight: '24px',
      letterSpacing: '0.15px',
      fontWeight: '400',
      ':last-child': {
        marginBottom: '0px',
      },
    },
    '& .title': {
      fontSize: '16px',
      color: theme.palette.text.primary,
      lineHeight: '18px',
      letterSpacing: '0.15px',
      fontWeight: '500',
      margin: '0 0 8px 0',
    },
  },
  '& .text': {
    '& .MuiTypography-root': {
      fontSize: '14px',
      marginBottom: 0,
    },
    div: {
      display: 'flex',
      alignItems: 'center',
    },
  },
}))
